import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | Lotus Family Dental" description="The page you're looking for doesn't exist." />
      <section className="min-h-[70vh] flex items-center justify-center px-4">
        <div className="text-center max-w-md">
          <div className="font-heading text-7xl lg:text-9xl font-light text-teal-600">404</div>
          <h1 className="mt-4 font-heading text-2xl lg:text-3xl font-medium text-slate-900">
            Page not found
          </h1>
          <p className="mt-3 text-slate-600">
            The page you are looking for has moved or no longer exists.
          </p>
          <Link
            to="/"
            className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-teal-600 text-white font-medium hover:bg-teal-700"
          >
            <Home className="w-4 h-4" /> Back to Home
          </Link>
        </div>
      </section>
    </>
  );
}
